var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getBadgeClass()},[_c('img',{class:_vm.getImageClass(),attrs:{"src":_vm.getImageSrc()}})])}
var staticRenderFns = []

export { render, staticRenderFns }